















import Vue from 'vue'

export default Vue.extend({
  props: {
    href: {
      type: String,
      required: true
    },
    analyticsNamespace: {
      type: String,
      required: true
    },
    green: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    linkClick(e: Event) {
      this.$analytics.recordEvent({
        namespace: this.analyticsNamespace,
        action: 'click'
      })
      this.$emit('click', e)
    }
  }
})
